export enum AnioInformacionEnum {
  AnioInformacion2024 = 2024,
  AnioInformacion2025 = 2025
}

export enum usuarioRolEnum {
  promotor = "Promotor",
  promotorId = 4,
  coordinador = "Coordinador",
  coordinadorId = 3,
  conadeId = 1,
  conade = "CONADE"
}

export enum AccionesEnum {
  GuardarUsuario = "2",
  ModificarUsuario = "7",
  usuarioInsertado = 'Insertado',
  usuarioActualizado = 'Actualizado',
  datosActualizados = 'DatosActualizados',
  InsertarEvento = "Insertar",
  EditarEvento = "Actualizar",
  EventoActualizado = 'actualizó',
  EventoAgregado = 'agregó',
  EventosActivos = 'Activo',
  descripcionEventos ='Descripcion',
  todasEdades = 'Todos',
  TotalMes = 'TOTAL',
  ActualizarGrupoActivacion = 'Actualizar',
  InsertarGrupoActivación = 'Insertar',
  CurpExito = 'Exitoso',
  ModalidadesTodas = 'Todas'
}

export enum MesesEnum {
  ENERO = 'ENERO',
  FEBRERO = 'FEBRERO',
  MARZO = 'MARZO',
  ABRIL = 'ABRIL',
  MAYO = 'MAYO',
  JUNIO = 'JUNIO',
  JULIO = 'JULIO',
  AGOSTO = 'AGOSTO',
  SEPTIEMBRE = 'SEPTIEMBRE',
  OCTUBRE = 'OCTUBRE',
  NOVIEMBRE = 'NOVIEMBRE',
  DICIEMBRE = 'DICIEMBRE'
}

export const CatalogoMeses: string[] = Object.values(MesesEnum);
